import { render, staticRenderFns } from "./ProductCollectionSidebar.vue?vue&type=template&id=2ba710a1&scoped=true&"
import script from "./ProductCollectionSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductCollectionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollectionSidebar.vue?vue&type=style&index=0&id=2ba710a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba710a1",
  null
  
)

component.options.__file = "ProductCollectionSidebar.vue"
export default component.exports